import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { guardaPrecio } from '../actions'
import { getProductoAdmin, guardaGrupo, borraGrupo, borraProducto, borraPrecio } from "../actions/admin";
import AdminMenu from '../components/admin_menu'
import ProductoOpciones from '../components/producto_opciones_admin'
import PrecioFila from '../components/admin_precio_fila'

class AdminProductos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      producto: null,
      stocks: ["FALTA EN STOCK", "HAY EN STOCK"],
      estados: ["NULO", "ACTIVO"],
      custom: ["SIN CUSTOM", "CUSTOMIZADO"]
    };
    this.upPrecio = this.upPrecio.bind(this);
    this.delPrecio = this.delPrecio.bind(this);
    this.agregaOpcion = this.agregaOpcion.bind(this);
    this.agregaPrecio = this.agregaPrecio.bind(this);
    this.agregaGrupo = this.agregaGrupo.bind(this);
    this.editaGrupo = this.editaGrupo.bind(this);
    this.borraGrupo = this.borraGrupo.bind(this);
    this.borra = this.borra.bind(this);
    
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
    if (this.props.match.params.id) {
      if (
        this.props.productos.prod == null ||
        (this.props.productos.prod != null &&
          this.props.productos.prod.id != this.props.match.params.id)
      ) {
        this.props.getProductoAdmin(this.props.match.params.id);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!this.props.productos.prod){
      this.props.history.push("/admin/productos");
    }
  }

  upPrecio(id, precio) {
    this.props.guardaPrecio(this.props.match.params.id, id, precio);
  }

  delPrecio(id_precio) {
    this.props.borraPrecio(this.props.match.params.id, id_precio);
  }

  agregaOpcion() {
    this.props.history.push("/admin/opcion/");
  }

  agregaPrecio() {
    this.props.history.push("/admin/precio/" + this.props.match.params.id);
  }

  agregaGrupo(){
    this.props.history.push("/admin/grupo/");
  }

  editaGrupo(id) {
    this.props.history.push("/admin/grupo/"+id);
  }

  borraGrupo(id) {
    if (window.confirm("ESTA POR BORRAR UN GRUPO, DESEA CONTINUAR?")) {
      var grupos = this.props.productos.prod.grupos.filter(g => {
        return g.id != id;
      });
      this.props.borraGrupo(this.props.match.params.id, grupos);
    } else {
      console.log("RECHAZO");
    }
  }

  borra() {
    if (window.confirm("ESTA POR BORRAR UN ELEMENTO, DESEA CONTINUAR?")) {
      var imagenes = []
      var customs = [];
      if ( this.props.match.params.id && this.props.productos.prod && this.props.productos.prod.hasOwnProperty("opciones")) {
        this.props.productos.prod.opciones.map(opcion => {
          opcion.items.map(item => {
            customs.push(item.id)
            if (item.hasOwnProperty("img") && item.img!=null){
              imagenes.push(item.img)
            }
          })
        });
      }
      //console.log(imagenes)
      //console.log(customs)
      //console.log("CONFIRMO");
      this.props.borraProducto(this.props.match.params.id,this.state.img, imagenes,customs);
    } else {
      //console.log("RECHAZO");
    }
  }

  render() {
    if (this.props.match.params.id && !this.props.productos.prod) {
      return <div>CARGANDO</div>;
    }

    var precios = [];
    var opciones = [];
    var grupos = [];

    if (
      this.props.match.params.id &&
      this.props.match.params.id === this.props.productos.prod.id &&
      this.props.productos.prod.hasOwnProperty("precios")
    ) {
      precios = this.props.productos.prod.precios.map((precio, i) => {
        return <PrecioFila key={i} upPrecio={this.upPrecio} delPrecio={this.delPrecio} datos={precio} />;
      });
    }

    if (
      this.props.match.params.id &&
      this.props.productos.prod &&
      this.props.productos.prod.hasOwnProperty("opciones")
    ) {
      opciones = this.props.productos.prod.opciones.map((opcion, i) => {
        return <ProductoOpciones key={i} datos={opcion} />;
      });
    }

    if(this.props.productos.prod.hasOwnProperty("grupos")){
      //console.log(this.props.productos.prod);
      grupos = this.props.productos.prod.grupos.map((grupo, i) => {
        return <li key={i} className="list-group-item">
            {grupo.nombre}
            <button type="button" className="btn btn-info float-right ml-2" onClick={e => this.borraGrupo(grupo.id)}>
              <i className="fas fa-trash-alt" />
            </button>
            <button type="button" className="btn btn-info float-right" onClick={e => this.editaGrupo(grupo.id)}>
              <i className="fas fa-pencil-alt" />
            </button>
          </li>;
      });
    }

    return <section className="row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-2 mb-3">
          <AdminMenu />
        </div>

        <div className="col-md-10 p-3">
          <div className="container">

            {this.props.match.params.id &&
            <div className="row">
            <Link to={"/admin/producto_form/" + this.props.productos.prod.id} className="btn btn-info float-left ml-2">
                EDITAR <i className="fas fa-pencil-alt" />
              </Link>
            <button type="button" className="btn btn-info float-right ml-2" onClick={e => this.borra()}>
                BORRAR <i className="fas fa-trash-alt" />
              </button>
            </div>
            }

            <div className="row">
              <h5 className="col-6" style={{ color: "#95c03f" }}>
                {this.props.productos.prod.rubro.nombre}
              </h5>
              <h5 className="col-6 text-right" style={{ color: "#95c03f" }}>
                {this.props.productos.prod.categoria.nombre}
              </h5>
            </div>

            <div>
              <h1 className="display-4">
                {this.props.productos.prod.nombre}
              </h1>
              <p>{this.props.productos.prod.descripcion}</p>
            </div>

            <div className="row">
              <h5 className="col-4" style={{ color: "#95c03f" }}>
                {this.state.stocks[this.props.productos.prod.stock]}
              </h5>
              <h5 className="col-4" style={{ color: "#95c03f" }}>
                MINIMO:{this.props.productos.prod.unicad.min} {this.props.productos.prod.unicad.etiqueta}
              </h5>
              <h5 className="col-4 text-right" style={{ color: "#95c03f" }}>
                MULTIPLO DE:{this.props.productos.prod.unicad.cant} {this.props.productos.prod.unicad.etiqueta}
              </h5>
            </div>

            <div className="row">
              <h5 className="col-6" style={{ color: "#95c03f" }}>
                {this.state.custom[this.props.productos.prod.custom]}
              </h5>
              <h5 className="col-6 text-right" style={{ color: "#95c03f" }}>
                {this.state.estados[this.props.productos.prod.estado]}
              </h5>
            </div>

            <div className="row">
              <div className="col-md-6">
                <hgroup className="row">
                  <h2 className="col-6">GRUPOS</h2>
                  <div className="col-6 text-right">
                    <button type="button" className="btn btn-info" onClick={this.agregaGrupo}>
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </hgroup>
                <ul className="list-group">{grupos}</ul>
                <hgroup className="row mt-2">
                  <h2 className="col-6">OPCIONES</h2>
                  <div className="col-6 text-right">
                    <button type="button" className="btn btn-info" onClick={this.agregaOpcion}>
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </hgroup>
                {opciones}
              </div>
              <table className="table col-md-6">
                <thead>
                  <tr>
                    <th scope="col">DESDE</th>
                    <th scope="col">PRECIO</th>
                    <th scope="col"></th>
                    <th scope="col">
                      <button type="button" className="btn btn-info" onClick={this.agregaPrecio}>
                        <i className="fas fa-plus" />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>{precios}</tbody>
              </table>
            </div>
          </div>
        </div>
      </section>;
  }
}

const mapStateToProps = state => {
	return {
    	productos: state.productos,
      usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return { getProductoAdmin: id => {
      dispatch(getProductoAdmin(id));
    }, guardaPrecio: (id_prod, id_precio, precio) => {
      dispatch(guardaPrecio(id_prod, id_precio, precio));
    }, guardaGrupo: (id_prod, datos) => {
      dispatch(guardaGrupo(id_prod, datos));
    }, borraGrupo: (id_prod, grupos) => {
      dispatch(borraGrupo(id_prod, grupos));
    }, borraProducto: (id,img, imgs,customs) =>{
      dispatch(borraProducto(id, img, imgs, customs));
    }, borraPrecio: (id_producto, id_precio) => {
      dispatch(borraPrecio(id_producto, id_precio));
    } 
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProductos)




// WEBPACK FOOTER //
// ./src/containers/admin_prod.js